export enum CancellationActionEnum {
  REQUEST_CANCELLATION = 'REQUEST_CANCELLATION',
  CONFIRM_CANCELLATION = 'CONFIRM_CANCELLATION',
  REFUSE_CANCELLATION = 'REFUSE_CANCELLATION',
  REFUND = 'REFUND',
}
